import { Injectable } from '@angular/core';
import { APISCockpit } from 'src/service/apis-cockpit';
import { HttpClient } from '@angular/common/http';
import { PoComboFilter, PoComboOption  } from '@po-ui/ng-components';
import { Observable , map } from 'rxjs';
import { ComponentesUtils } from 'src/utils/components-utils';

@Injectable({ providedIn: 'root' })
export class CompanyServices implements PoComboFilter {

  constructor(private readonly apiCockpit: APISCockpit, public httpClient: HttpClient) { }
  private readonly componentsUtils = new ComponentesUtils();

  
  getFilteredData(param: any): Observable<Array<PoComboOption>> {
    let options: Array<PoComboOption> = [];
    const params = { name: param.value };
    let apiColigada = this.getAPIColigada();
  
    apiColigada += `&fields=code,nickname,name`;

    if (params && params.name !== '') {
      if (Number(params.name)) {
        apiColigada += `&$filter=code eq ${Number(params.name)}`;
      } else {
        apiColigada += `&$filter=contains(nickname, '${params.name}')`;
      }
    }
  
    return this.apiCockpit.getDataInfoObservable(apiColigada).pipe(
      map((response: any) => {
        options = this.componentsUtils.convertToArrayComboOption(response.items, 'nickname');
        return options;
      })
    );
  }
  
  getObjectByValue(value: any): Observable<PoComboOption> {
    if (Number(value)) {
      const apiColigada = this.getAPIColigada() + `&$filter=code eq ${Number(value)}`;
      return this.apiCockpit.getDataInfoObservable(apiColigada).pipe(map(item => this.componentsUtils.convertToArrayComboOption(item.items, 'nickname')[0]));
    }
    else {
      const apiColigada = this.getAPIColigada() + `&$filter=contains(nickname, '${value}')`;
      return this.apiCockpit.getDataInfoObservable(apiColigada).pipe(map(item => this.componentsUtils.convertToArrayComboOption(item.items, 'nickname')[0]));
    }
  }
	

  getAPIColigada() {
    return '/api/construction-projects/v1/companies?page=1&pageSize=1000&order=nickname';
  }

}
